import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Box, Container, Typography, Link, Tabs, Tab } from '@mui/material';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
import BreadcrumbsList from 'src/components/general/BreadcrumbsList';
import useStyles from '../styles';
const tabGroupExaple = "\n<Tabs\n  value={value}\n  onChange={handleChange}\n  aria-label=\"tabs\"\n>\n  <Tab value=\"one\" label=\"Item One\" />\n</Tabs>\n";
const tabsOuterExample = "\n<Tabs\n  type=\"navigation\"\n  value={value}\n  onChange={handleChange}\n  aria-label=\"tabs navigation\"\n>\n  <Tab value=\"one\" label=\"Item One\" />\n</Tabs>\n";
const tabsInnerExample = "\n<Tabs\n  type=\"innerNavigation\"\n  value={value}\n  onChange={handleChange}\n  aria-label=\"tabs navigation\"\n>\n  <Tab value=\"one\" label=\"Item One\" />\n</Tabs>\n";
const breadcrumbs = "\nimport BreadcrumbsList from 'src/components/general/BreadcrumbsList';\n\n<BreadcrumbsList breadcrumbsArray={[ {title: 'Dashboard', link: '/'} ]} />\n";
const breadcrumbsBar = "\nimport BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';\n\n<BreadcrumbsBar breadcrumbsArray={[ {title: 'Dashboard', link: '/'} ]} showMembers />\n";
export default function LvNavigation() {
  const classes = useStyles();
  const _useState = useState('one'),
    _useState2 = _slicedToArray(_useState, 2),
    tabGroupValue = _useState2[0],
    setValue = _useState2[1];
  const handleChange = (event, newValue) => setValue(newValue);
  const _useState3 = useState('one'),
    _useState4 = _slicedToArray(_useState3, 2),
    tabNavigationValue = _useState4[0],
    setNavigationValue = _useState4[1];
  const handleNavigationChange = (event, newValue) => setNavigationValue(newValue);
  const breadcrumbsArray = [{
    title: 'Home'
  }, {
    title: '2nd level'
  }, {
    title: '3rd level'
  }, {
    title: '4th level'
  }, {
    title: 'Active level'
  }];
  const breadcrumbsBarArray = [{
    title: 'Dashboard',
    link: '/'
  }, {
    title: '8558 Green Rd., Santa Monica, 90402'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Navigation and positioning elements"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Tab group "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-tabs/#basic-tabs",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Tabs, {
    value: tabGroupValue,
    onChange: handleChange,
    "aria-label": "tabs example"
  }, /*#__PURE__*/React.createElement(Tab, {
    value: "one",
    label: "Item One"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "two",
    label: "Item Two"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "three",
    label: "Item Three"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "four",
    label: "Item Four"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "five",
    label: "Item Five"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "six",
    label: "Item Six"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, tabGroupExaple), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Tab navigation outer"), /*#__PURE__*/React.createElement(Tabs, {
    type: "navigation",
    value: tabNavigationValue,
    onChange: handleNavigationChange,
    "aria-label": "tabs navigation"
  }, /*#__PURE__*/React.createElement(Tab, {
    value: "one",
    label: "Item One"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "two",
    label: "Item Two"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "three",
    label: "Item Three"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "four",
    label: "Item Four"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "five",
    label: "Item Five"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "six",
    label: "Item Six"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, tabsOuterExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Tab navigation inner"), /*#__PURE__*/React.createElement(Tabs, {
    type: "innerNavigation",
    value: "one",
    "aria-label": "tabs navigation"
  }, /*#__PURE__*/React.createElement(Tab, {
    value: "one",
    label: "Item One"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "two",
    label: "Item Two"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "three",
    label: "Item Three"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "four",
    label: "Item Four"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "five",
    label: "Item Five"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "six",
    label: "Item Six"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, tabsInnerExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Breadcrumbs"), /*#__PURE__*/React.createElement(BreadcrumbsList, {
    breadcrumbsArray: breadcrumbsArray
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, breadcrumbs), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Breadcrumbs bar"), /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbsBarArray,
    showMembers: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, breadcrumbsBar))));
}